import { t } from "@ebay/i18n-ebay";
import { APR_DATE, APR_RATE, UK } from "../../../../../common/constants";

<div class="footer-container">
  <if(input.site == UK)>
    <div class="details-container">
      <p data-testid=`paypal-eligibility-desc-${input.site.toLowerCase()}`>
        ${t("calculator/index", "PAYPAL_ELIGIBILITY_DESC")}
      </p>
    </div>
  </if>
  <div class=`apply-button-container text-center`>
    <ebay-button
      size="large"
      variant="form"
      id="apply-button"
      value="Apply"
      on-click("openPaypal")
      data-testid="apply-button"
    >
      ${t("calculator/index", "APPLY_PAYPAL_BUTTON")}
    </ebay-button>
  </div>
  <if(input.site == UK)>
    <div data-testid="rep-example-uk">
      <p
        class="calc-representative"
        data-testid=`example-apr-${input.site.toLowerCase()}`
      >
        ${t("calculator/index", `EXAMPLE_APR_${input.site}`)}
      </p>
      <div style="padding-left:14px">
        <div class="apr-heading">
          ${t("calculator/index", `PURCHASE_RATE`)}
          <p class="apr-value">
            23.9%
          </p>
        </div>
        <div class="apr-heading representative-left-padding">
          ${t("calculator/index", `REPR_APR`)}
          <p class="apr-value">
            23.9% APR
          </p>
        </div>
        <div class="apr-heading representative-left-padding no-right-border">
          ${t("calculator/index", `ASSUMED_CREDIT_LIMIT`)}
          <p class="apr-value">
            £1,200
          </p>
        </div>
      </div>
    </div>
    <div class="accordion accordion-flush" id="accordionFlushContainer">
      <for|entry, index| of=["ONE", "TWO", "THREE", "FOUR", "FIVE"]>
        <div key=index.toString() class="accordion-item">
          <div class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target=`#flush-collapse${entry}`
              aria-expanded="false"
              aria-controls=`flush-collapse${entry}`
              data-testid=`faq-heading-${entry.toLowerCase()}-${input?.site?.toLowerCase()}`
            >
              ${t("calculator/index", `FAQ_HEADING_${entry}_${input.site}`)}
            </button>
          </div>
          <div id=`flush-collapse${entry}` class="accordion-collapse collapse">
            <div class="accordion-body">
              <p data-testid=`faq-desc-${entry.toLowerCase()}-${input?.site?.toLowerCase()}`>
                ${t("calculator/index", `FAQ_DESC_${entry}_${input.site}`)}
              </p>
              <if(entry == "ONE")>
                <p data-testid=`faq-sub-${input?.site?.toLowerCase()}`>
                  <br>
                  ${t(
                    "calculator/index",
                    `FAQ_DESC_${entry}_SUBONE_${input.site}`,
                  )}
                  <br>
                  ${t(
                    "calculator/index",
                    `FAQ_DESC_${entry}_SUBTWO_${input.site}`,
                  )}
                </p>
                <p>
                  <b>
                    ${t(
                      "calculator/index",
                      `FAQ_DESC_${entry}_SUBTHREE_${input.site}`,
                    )}
                  </b>
                  <br>
                  ${t(
                    "calculator/index",
                    `FAQ_DESC_${entry}_SUBFOUR_${input.site}`,
                  )}
                </p>
              </if>
            </div>
          </div>
        </div>
      </for>
    </div>
    <div class="t-and-c">
      <p data-testid=`footer-para-1-${input?.site?.toLowerCase()}`>
        ${t("calculator/index", `FOOTER_PARA_1_${input.site}`)}
        <if(input.site == UK)>
          , please click
          <a
            class="legal-link"
            data-testid=`footer-link-${input?.site?.toLowerCase()}`
            href="https://pages.ebay.co.uk/idd-ebay-sellers/"
            target="_blank"
          >
            here
          </a>
          <span>.</span>
        </if>
      </p>
      <p data-testid=`footer-para-2-${input.site.toLowerCase()}`>
        ${t("calculator/index", `FOOTER_PARA_2_${input.site}`)}
      </p>
    </div>
  </if>
  <else>
    <div class="details-container-us">
      <for|entry, index| of=[1, 2, 3]>
        <p
          key=index.toString()
          data-testid=`footer-para-${entry}-${input?.site?.toLowerCase()}`
        >
          ${t(
            "calculator/index",
            `FOOTER_PARA_${entry}_${input.site}`,
            entry == 2
              ? {
                  aprRate: APR_RATE,
                  aprDate: APR_DATE,
                }
              : {},
          )}
          <if(entry == 2)>
            &nbsp Read the complete
            <a
              class="legal-link"
              href="https://www.paypal.com/us/webapps/mpp/bmlterms"
            >
              Terms and Conditions.
            </a>
          </if>
        </p>
      </for>
    </div>
    <div class="accordion accordion-flush" id="accordionFlushContainer">
      <div
        class="accordion-item"
        style="border-bottom: 1px solid rgba(0, 0, 0, .125);"
      >
        <div class="accordion-header">
          <button
            class="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target=`#flush-collapse`
            aria-expanded="false"
            aria-controls=`flush-collapse`
            data-testid=`faq-heading-${input?.site?.toLowerCase()}`
          >
            ${t("calculator/index", `FAQ_HEADING_US`)}
          </button>
        </div>
        <div id=`flush-collapse` class="accordion-collapse collapse">
          <div class="accordion-body">
            <for|entry, index| of=["ONE", "TWO", "THREE", "FOUR", "FIVE"]>
              <p data-testid=`faq-desc-${entry.toLowerCase()}-${input?.site?.toLowerCase()}`>
                ${t("calculator/index", `FAQ_DESC_${entry}_${input.site}`)}
              </p>
              <!-- <br> -->
            </for>
          </div>
        </div>
      </div>
    </div>
    <h2 class="easy-pmt-details pt-2">
      <a
        href="https://www.paypal.com/us/webapps/mpp/paypal-credit/faq/"
        target="_blank"
        on-click("trackPaypalFaq")
      >
        FAQs
      </a>
    </h2>
  </else>
</div>
